import { Component, ChangeDetectionStrategy, input, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { ToggleButtonGroupComponent, ToggleButtonComponent } from '@zerops/zui/toggle-button-group';
import { ZefFormsModule } from '@zerops/zef/forms';
import { IntegrationTokenRoleCode, TokenRoleOption } from '@zerops/models/integration-token';
import { FormControlState } from 'ngrx-forms';
import { ZuiSeparatorComponent } from '../separator';

@Component({
  selector: 'zui-token-primary-role-selector',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    MatSlideToggleModule,
    ZefFormsModule,
    ToggleButtonGroupComponent,
    ToggleButtonComponent,
    ZuiSeparatorComponent
  ],
  templateUrl: './token-primary-role-selector.component.html',
  styleUrl: './token-primary-role-selector.component.scss'
})
export class TokenPrimaryRoleSelectorComponent {
  // # Inputs
  availableRoles = input.required<TokenRoleOption[]>();
  roleCodeControl = input.required<FormControlState<IntegrationTokenRoleCode>>();
  canCreateProjectsControl = input.required<FormControlState<boolean>>();
  disabled = input<boolean>(false);
  // Hide create projects toggle for GUEST users (NO_ACCESS + canCreateProjects=false)
  hideCreateProjectsToggle = input<boolean>(false);

  // # Computed
  // Hide role toggles when only one option - it's auto-selected
  showRoleToggles = computed(() => this.availableRoles().length > 1);

  showCreateProjectsToggle = computed(() =>
    !this.hideCreateProjectsToggle() &&
    this.roleCodeControl()?.value === IntegrationTokenRoleCode.NoAccess
  );
}
